
import { Volume2 } from "lucide-react";

interface CallAudioSectionProps {
  audioUrl: string;
}

export const CallAudioSection = ({ audioUrl }: CallAudioSectionProps) => {
  return (
    <div>
      <h3 className="text-sm font-medium mb-2 flex items-center">
        <Volume2 className="h-4 w-4 mr-2" />
        Call Recording
      </h3>
      <audio 
        src={audioUrl} 
        controls 
        className="w-full"
      />
    </div>
  );
};
